const TrendIcon = ({ className = '' }) => {
  return (
    <svg
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.1357 6.75C41.6454 6.74998 45.9642 6.74996 49.3906 7.12118C52.8872 7.50002 55.7203 8.28697 58.1393 10.0445C59.6037 11.1084 60.8916 12.3963 61.9555 13.8607C63.713 16.2797 64.5 19.1128 64.8788 22.6094C65.25 26.0358 65.25 30.3545 65.25 35.864V36.1358C65.25 41.6453 65.25 45.9642 64.8788 49.3906C64.5 52.8872 63.713 55.7203 61.9555 58.1393C60.8916 59.6037 59.6037 60.8916 58.1393 61.9555C55.7203 63.713 52.8872 64.5 49.3906 64.8788C45.9642 65.25 41.6455 65.25 36.136 65.25H35.8642C30.3547 65.25 26.0358 65.25 22.6094 64.8788C19.1128 64.5 16.2797 63.713 13.8607 61.9555C12.3963 60.8916 11.1084 59.6037 10.0445 58.1393C8.28697 55.7203 7.50002 52.8872 7.12118 49.3906C6.74996 45.9642 6.74998 41.6454 6.75 36.1357V35.8643C6.74998 30.3546 6.74996 26.0358 7.12118 22.6094C7.50002 19.1128 8.28697 16.2797 10.0445 13.8607C11.1084 12.3963 12.3963 11.1084 13.8607 10.0445C16.2797 8.28697 19.1128 7.50002 22.6094 7.12118C26.0358 6.74996 30.3546 6.74998 35.8643 6.75H36.1357ZM53.0201 28.4195C53.5673 27.3038 53.1065 25.9558 51.9909 25.4085C50.8753 24.8612 49.5272 25.322 48.9799 26.4377L44.5989 35.3688C43.241 38.1371 39.25 38.0019 38.0825 35.1481C35.445 28.7009 26.4287 28.3955 23.3609 34.6494L18.9799 43.5805C18.4327 44.6962 18.8935 46.0442 20.0091 46.5915C21.1247 47.1387 22.4728 46.678 23.0201 45.5623L27.4011 36.6312C28.759 33.8629 32.75 33.9981 33.9175 36.8519C36.555 43.299 45.5713 43.6045 48.6391 37.3506L53.0201 28.4195Z"
        fill="#FF9060"
      />
    </svg>
  )
}

export default TrendIcon
